export const AI_CHAT_EVIDENCE_FILTER_LABEL = 'From AI chat';
export const IDEA_AI_CHAT_EVIDENCE_FILTER_APPLIED = 'idea-ai-chat-evidence-filter-applied';
export const IDEA_AI_EVIDENCE_CARD_OPENED_SCROLL = 'idea-ai-evidence-card-opened-scroll';

export const CLASS_NAMES = {
  tabAll: 'idea-tab-all',
  tabValidated: 'idea-tab-validated',
  tabFormalRequests: 'idea-tab-formal-requests',
  selectAllCheckbox: 'idea-select-all-checkbox',
  sortButton: 'idea-sort-button',
  addButton: 'idea-add-button',
  searchInput: 'idea-search-input',
  suggestedEvidenceSection: 'idea-suggested-evidence-section',
  validatedEvidenceSection: 'idea-validated-evidence-section',
  evidenceCard: 'idea-evidence-card',
  evidenceCardTitle: 'idea-evidence-card-title',
  evidenceCardDescription: 'idea-evidence-card-description',
  evidenceCardType: 'idea-evidence-card-type',
  evidenceCardCustomer: 'idea-evidence-card-customer',
  evidenceCardCreatedDate: 'idea-evidence-card-created-date',
  evidenceCardAccountArr: 'idea-evidence-card-account-arr',
  evidenceCardOpportunity: 'idea-evidence-card-opportunity',
  showAllButton: 'idea-show-all-button',
  evidenceDrawer: 'idea-evidence-drawer',
  evidenceDrawerTitle: 'idea-evidence-drawer-title',
} as const;